__turbopack_context__.v({
  "container": "TalentAcrossIndustries-module-scss-module__oOnmGq__container",
  "desktopBody": "TalentAcrossIndustries-module-scss-module__oOnmGq__desktopBody",
  "heading": "TalentAcrossIndustries-module-scss-module__oOnmGq__heading",
  "iconFallback": "TalentAcrossIndustries-module-scss-module__oOnmGq__iconFallback",
  "infoCard": "TalentAcrossIndustries-module-scss-module__oOnmGq__infoCard",
  "infoHeader": "TalentAcrossIndustries-module-scss-module__oOnmGq__infoHeader",
  "infoIcon": "TalentAcrossIndustries-module-scss-module__oOnmGq__infoIcon",
  "infoIconRaw": "TalentAcrossIndustries-module-scss-module__oOnmGq__infoIconRaw",
  "layout": "TalentAcrossIndustries-module-scss-module__oOnmGq__layout",
  "list": "TalentAcrossIndustries-module-scss-module__oOnmGq__list",
  "listHeader": "TalentAcrossIndustries-module-scss-module__oOnmGq__listHeader",
  "listRow": "TalentAcrossIndustries-module-scss-module__oOnmGq__listRow",
  "mobileBody": "TalentAcrossIndustries-module-scss-module__oOnmGq__mobileBody",
  "pill": "TalentAcrossIndustries-module-scss-module__oOnmGq__pill",
  "pillLabel": "TalentAcrossIndustries-module-scss-module__oOnmGq__pillLabel",
  "pillRow": "TalentAcrossIndustries-module-scss-module__oOnmGq__pillRow",
  "source": "TalentAcrossIndustries-module-scss-module__oOnmGq__source",
  "statRow": "TalentAcrossIndustries-module-scss-module__oOnmGq__statRow",
  "tab": "TalentAcrossIndustries-module-scss-module__oOnmGq__tab",
  "tabActive": "TalentAcrossIndustries-module-scss-module__oOnmGq__tabActive",
  "tabIcon": "TalentAcrossIndustries-module-scss-module__oOnmGq__tabIcon",
  "tabIconRaw": "TalentAcrossIndustries-module-scss-module__oOnmGq__tabIconRaw",
  "tabLabel": "TalentAcrossIndustries-module-scss-module__oOnmGq__tabLabel",
  "tabsGrid": "TalentAcrossIndustries-module-scss-module__oOnmGq__tabsGrid",
});
